import AdditionalInfoService from './service';
import {
  GetAdditionalInfoDetailsResponseData,
  GetAdditionalInfoRequestsData,
  GetAdditionalInfoRequestsParams,
} from './types';

export const ADDITIONAL_INFO_QUERY_KEYS = {
  GET_ADDITIONAL_INFO_FULL: 'GET_ADDITIONAL_INFO_FULL',
  GET_ALL_REQUESTS: 'GET_ALL_ADDITIONAL_INFO_REQUESTS',
};

export class AdditionalInfoQueries {
  public static readonly getAdditionalInfoDetails = async (
    ormAdditionalInfoActionID: string,
    requestID: number,
    version: number
  ): Promise<GetAdditionalInfoDetailsResponseData> => {
    const { data } = await AdditionalInfoService.getAdditionalInfoDetails(
      ormAdditionalInfoActionID,
      requestID,
      version
    );
    return data;
  };

  public static readonly getAdditionalInfoRequests = async ({
    pageNumber = 1,
    itemsPerPage = 10,
    status,
    requestID,
    version,
  }: GetAdditionalInfoRequestsParams): Promise<GetAdditionalInfoRequestsData> => {
    const { data } = await AdditionalInfoService.getAdditionalInfoRequests({
      pageNumber,
      itemsPerPage,
      status,
      requestID,
      version,
    });
    return data;
  };
}
